import { Component, OnInit, ChangeDetectorRef,SimpleChanges } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';
import { UntypedFormGroup } from '@angular/forms';
import { AudioUploadModel } from '@app/components/controls/utilities/models/audio-upload-model';
import { EmbedModel } from '@app/components/controls/utilities/models/embed-model';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { AppInitializerService } from '@app/app-initializer.service';
import { PopupComponent } from '@app/components/popup/popup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { VideoUploadModel } from '@app/components/controls/utilities/models/video-upload-model';
import { FileUploadModel } from '@app/components/controls/utilities/models/file-upload-model';
import { QuillEditorModel } from '@app/components/controls/utilities/models/quill-editor-model';
import { DropDownModel } from '@app/components/controls/utilities/models/drop-down-model';
import { CheckBoxModel } from '@app/components/controls/utilities/models/check-box-model';
import { BaseService } from '@app/system/services/base.service';

import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

import * as pdfjsLib from 'pdfjs-dist';
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min';
import { ImageUploadModel } from '@app/components/controls/utilities/models/image-upload-model';
import { SliderConfig } from '@app/components/utilities/models/slider-model';
import { DatePickerModel } from '@app/components/controls/utilities/models/date-picker-model';
import { ApiService as ChannelsApiService } from '@app/modules/channels/utilitites/services/api.service';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';
import { PlaylistCard } from '@app/components/widget/playlist-card/playlist-card.component';
import { EventCard } from '@app/components/widget/event-card/event-card.component';
import { ApiService as ExternalEventApiService } from '@app/modules/external-event/utilities/services/api.service';
import { ApiService as MOOCApiService } from '@app/modules/mooc/utilities/services/api.service';
import { ApiService as InternalEventApiService } from '@app/modules/internal-event/utilities/services/api.service';
import { ApiService as KnowledgeBeadApiService } from '@app/modules/knowledge-bead/utilities/services/api.service';
import { NotificationService } from '@app/system/error-handler/notification/notification.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { map } from 'rxjs/operators';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

@Component({
	selector: 'app-resource-forms',
	templateUrl: './resource-forms.component.html',
	styleUrls: ['./resource-forms.component.scss']
})
export class ResourceFormsComponent implements OnInit {

	action: 'addResource' | 'editResource' | 'resourceFormat' | 'forwardResource' | 'reject' | 'guideline' | 'settings' | 'editBeadResource' | 'viewImage' | 'editImageResource' | 'makePublic' | 'resourceFilter' | 'addScorm' | 'editScorm';
	formFields: any = [];
	config = { fxFlex: 100 };
	formObject;
	resourceFormObject;
	skillFormObject;
	keywordsFormObject;
	makePublicFormObject;
	submitDisable = true;
	loader = false;
	popupRef;
	showHelp = false;
	formPopup = true;
	resourceFields = [];
	skillField = [];
	keywordsField = [];
	resourceFormatData;
	resourceDetail;
	form: UntypedFormGroup;
	skillForm: UntypedFormGroup;
	skills: AutoCompleteModel;
	clearTimeout;
	title: string;
	resourceFormatList = [];
	languageCode = 'en';
	helpTriggered = false;
	currentUser;
	info = '';
	resourceType;
	formObjectData = {
		form: null,
		fields: []
	};
	linkedResourceField = [];
	visibilityField = [];
	selectedResources = [];
	tabIndex = 0;
	settingsData;
	documentLoader = false;
	deviceDetails;
	imageIndex;
	imageList = [];
	mainSlider: SliderConfig = {
		items: 1,
		stagePadding: 0,
		dragEndSpeed: 600,
		dots: false,
		navSpeed: 600
	};
	currentFieldColumn = '';
	showThumbnail = true;
	moocAdd = false;
	externalEventAdd = false;
	record;
	infoTabData = [];
	actionFrom: string;
	resourceList: any = [];
	MB_IN_BYTES = 1024 * 1024;
	FIXED_CHUNK_SIZE = 50 * this.MB_IN_BYTES;
	uploadProgress: number = 0;
	parts: any = [];


	showUploadProgress = false;
	progress: number = 0;
	totalFileSizeInBytes;
	fileName;
	internetDown = false;
	setUploadID = null;
	uploadFailed = false;
	uploadType: any = 1;
	fileCompleted = 0;
	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService,
		private globalApiService: GlobalApiService,
		private appInit: AppInitializerService,
		private popup: MatDialog,
		private apiService: ApiService,
		private externalEventApiService: ExternalEventApiService,
		private moocApiService: MOOCApiService,
		private baseService: BaseService,
		private internalEventApiService: InternalEventApiService,
		private knowledgeBeadApiService: KnowledgeBeadApiService,
		public detectDevice: DetectDeviceService,
		private channelsApiService: ChannelsApiService,
		public notificationService: NotificationService,
		private cd: ChangeDetectorRef
	) {
		this.currentUser = this.gfService.sessionUser;

	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
		if (!['resourceFormat', 'guideline', 'viewImage', 'resourceFilter'].includes(this.action)) {
			this.baseService.formView = true;
		}

		if (this.action === 'addResource' || this.action === 'editResource' || this.action === 'editBeadResource') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			const title: TextBoxModel = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('title'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('content_title')
			};
			const duration: TextBoxModel = {
				fieldColumn: 'duration',
				additionalMetaData: {
					max: 100,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				// validationRegex: '^(?:2[0-3]|[01]?[0-9]):[0-5][0-9]:[0-5][0-9]$',
				validationRegex: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$',
				fieldCaption: this.locale.translate('duration'),
				fieldHelpText: null,
				fieldOrder: 4,
				validationMessage: this.locale.translate('enter_valid_duration_format'),
				fieldPlaceholder: this.locale.translate('time_format')
			};
			const description: TextAreaModel = {
				fieldColumn: 'description',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('desc'),
				fieldHelpText: null,
				fieldOrder: 3,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('desc')
			};

			const uploadVideo: VideoUploadModel = {
				fieldCaption: this.locale.translate('upload'),
				fieldColumn: 'uploadVideo',
				fieldOrder: 1,
				fieldType: 'videoUpload',
				validationMessage: 'Invalid file.',
				fieldHelpText: '',
				isRequired: true,
				isHidden: true,
				additionalMetaData: {
					showLabel: false,
					fileSize: '100MB',
					supportedType: ['.mp4', '.mpeg'],
					thumbnailMaxSize: '1MB',
					thumbnailFormat: ['.jpg', '.jpeg', '.png', '.gif'],
					thumbnailWidth: 720,
					thumbnailHeight: 480
				},
				isReadonly: false,
				value: null
			};

			const audioUpload: AudioUploadModel = {
				fieldColumn: 'audioUpload',
				fieldOrder: 1,
				additionalMetaData: {
					fileSize: '30MB',
					showLabel: false,
					supportedType: ['.mp3'],
					thumbnailFormat: ['.jpg', '.jpeg', '.png'],
					thumbnailMaxSize: '1MB',
					thumbnailWidth: 450,
					thumbnailHeight: 450
				},
				fieldType: 'audioUpload',
				isHidden: true,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('audio_upload'),
				value: null
			};
			const uploadFile: FileUploadModel = {
				fieldCaption: this.locale.translate('upload_file'),
				fieldColumn: 'uploadFile',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 1,
				fieldType: 'fileUpload',
				fieldHelpText: this.locale.translate('upload_supported_file'),
				fieldPlaceholder: this.locale.translate('choose_file'),
				isRequired: true,
				isHidden: true,
				additionalMetaData: {
					showLabel: false,
					fileSize: '5MB',
					supportedType: ['.pdf', '.ppt', '.pptx', '.xls', '.xlsx', '.doc', '.docx'],
					drag: true
				},
				isReadonly: false,
				value: null
			};

			const embed: EmbedModel = {
				additionalMetaData: {},
				embedAction: {
					type: 'icon',
					icon: 'done',
					tooltip: this.locale.translate('embed_the_url')
				},
				fieldColumn: 'embed',
				fieldOrder: 1,
				fieldType: 'embed',
				isHidden: true,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('embed'),
				fieldHelpText: null,
				fieldHelpTextLong: null,
				validationMessage: this.locale.translate('invalid_embed_link'),
				fieldPlaceholder: this.locale.translate('embed_link_desc')
			};

			const page: QuillEditorModel = {
				fieldCaption: this.locale.translate('page'),
				fieldColumn: 'page',
				validationRegex: '',
				validationMessage: '',
				fieldOrder: 1,
				fieldType: 'quillEditor',
				fieldHelpText: '',
				isRequired: true,
				isHidden: true,
				additionalMetaData: {
					showLabel: true,
					imageUploadData: {
						fileSize: '10MB',
						supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
						url: ''
					}
				},
				isReadonly: false,
				value: null
			};

			const imageUpload: ImageUploadModel = {
				fieldCaption: this.locale.translate('cover_image'),
				fieldColumn: 'imageUpload',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 1,
				fieldType: 'imageUpload',
				fieldHelpText: null,
				fieldPlaceholder: this.locale.translate('drop_click_image_upload'),
				isRequired: true,
				isHidden: true,
				additionalMetaData: {
					showLabel: false,
					crop: true,
					fileSize: '10MB',
					supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
					max: 20
				},
				isReadonly: false,
				value: null
			};

			const authors: AutoCompleteModel = {
				fieldColumn: 'authors',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('authors'),
				fieldOrder: 4,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('search_user')
			};

			const resourceTypeID: DropDownModel = {
				fieldCaption: this.locale.translate('resource_type'),
				fieldColumn: 'resourceTypeID',
				validationMessage: '',
				fieldOrder: 5,
				fieldType: 'dropDown',
				fieldHelpText: '',
				isRequired: true,
				isHidden: false,
				additionalMetaData: {},
				options: [],
				isReadonly: false,
				value: null,
				isMultiple: false
			};

			const keywords: AutoCompleteModel = {
				fieldColumn: 'keywords',
				fieldCaption: this.locale.translate('select_enter_keywords'),
				additionalMetaData: {},
				fieldType: 'autoComplete',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				value: null,
				fieldPlaceholder: this.locale.translate('keywords_resource'),
				selectedValue: [],
				type: 'general',
				isMultiple: true,
				options: [],
				// fieldHelpText: this.locale.translate('keywords_help_text'),
				preDefined: false
			};

			const skills: AutoCompleteModel = {
				fieldColumn: 'skills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					defaultWeightage: 1,
					minWeightage: 1,
					showHelp: true
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('select_enter_skills'),
				fieldOrder: 1,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('skills'),
				type: 'weightage'
			};

			const linkedResource: AutoCompleteModel = {
				fieldColumn: 'linkedResource',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('type_title'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('type_title')
			};

			const departments: AutoCompleteModel = {
				fieldColumn: 'departments',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('departments'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('departments')
			};
			const functionalRoles: AutoCompleteModel = {
				fieldColumn: 'functionalRoles',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('functional_roles'),
				fieldOrder: 2,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('functional_roles')
			};
			const countries: AutoCompleteModel = {
				fieldColumn: 'countries',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('countries'),
				fieldOrder: 3,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('countries')
			};
			const authority: TextBoxModel = {
				fieldColumn: 'authority',
				fieldCaption: this.locale.translate('certification_authority'),
				additionalMetaData: {
					maxChar: 100
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				value: null,
				fieldPlaceholder: this.locale.translate('certification_authority')
			};
			const reimbursementApproval: CheckBoxModel = {
				fieldColumn: 'reimbursementApproval',
				additionalMetaData: {
					showLabel: true
				},
				fieldType: 'checkBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				options: [{
					key: true,
					value: this.locale.translate('users_can_request_for_reimbursement')
				}],
				fieldCaption: null,
				fieldOrder: 2
			};
			const date: DatePickerModel = {
				fieldColumn: 'startDate',
				additionalMetaData: {
					// maxDate: 0
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				fieldCaption: this.locale.translate('date'),
				fieldPlaceholder: this.locale.translate('date'),
				value: null
			};
			const notes: TextAreaModel = {
				fieldColumn: 'notes',
				additionalMetaData: {
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: true,
				isReadonly: true,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('notes'),
				fieldHelpText: this.locale.translate('you_may_mention_reimbursement_limit_criteria_etc'),
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('notes')
			};

			const channel: AutoCompleteModel = {
				fieldColumn: 'channel',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('channels'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_channels')
			};

			if (this.currentUser.weightageData) {
				skills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});

			}
			if (this.resourceFormatData) {
				if (!resourceTypeID.isHidden) {
					const editorAPiData = {
						format: this.resourceFormatData.value
					};
					this.apiService.getEditorialResource(editorAPiData, {}).subscribe(
						(response) => {
							if (response) {
								resourceTypeID.options = response.records.map((data) => {
									return {
										key: data.resourceTypeID,
										value: data.name
									};
								});

							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								snackBar: {
									position: 'before'
								}
							});
						}
					)
						.add(() => {
						});
				}
				if (this.resourceFormatData.key === 'document') {
					uploadFile.isHidden = false;
					this.title = this.locale.translate('create_document');
					this.currentFieldColumn = uploadFile.fieldColumn;
				} else if (this.resourceFormatData.key === 'video') {
					uploadVideo.isHidden = false;
					this.title = this.locale.translate('create_video');
					this.currentFieldColumn = uploadVideo.fieldColumn;
				} else if (this.resourceFormatData.key === 'audio') {
					audioUpload.isHidden = false;
					this.title = this.locale.translate('create_audio');
					this.currentFieldColumn = audioUpload.fieldColumn;
				} else if (this.resourceFormatData.key === 'link') {
					embed.isHidden = false;
					this.title = this.locale.translate('create_external_link');
					this.currentFieldColumn = embed.fieldColumn;
				} else if (this.resourceFormatData.key === 'page') {
					page.isHidden = false;
					this.title = this.locale.translate('create_page');
				} else if (this.resourceFormatData.key === 'image') {
					imageUpload.isHidden = false;
					this.title = this.locale.translate('create_image');
					this.currentFieldColumn = imageUpload.fieldColumn;
				}
				if (this.action === 'editResource' || this.action === 'editBeadResource') {
					imageUpload.isHidden = true;
					uploadFile.isHidden = true;
					uploadVideo.isHidden = true;
					audioUpload.isHidden = true;
					embed.isHidden = true;
					if (this.resourceFormatData.key === 'document') {
						this.title = this.locale.translate('edit_document');
					} else if (this.resourceFormatData.key === 'video') {
						this.title = this.locale.translate('edit_video');
					} else if (this.resourceFormatData.key === 'audio') {
						this.title = this.locale.translate('edit_audio');
					} else if (this.resourceFormatData.key === 'link') {
						this.title = this.locale.translate('edit_external_link');
					} else if (this.resourceFormatData.key === 'page') {
						this.title = this.locale.translate('edit_page');
					} else if (this.resourceFormatData.key === 'image') {
						this.title = this.locale.translate('edit_image');
					}
					const headers: any = {
						lanCode: sessionStorage.getItem('locale') || 'en'
					};
					this.apiService.detail(this.resourceDetail.resourceID, headers).subscribe(
						(response) => {
							if (response) {
								this.resourceDetail = response;
								this.resourceDetail.status = this.baseService.referenceType('resourceStatus', this.resourceDetail.status);
								this.resourceDetail.resourceTypeID = this.baseService.referenceType(
									'resourceType',
									this.resourceDetail.resourceTypeID
								);
								if (this.resourceDetail.resourceFormat && this.resourceDetail.resourceTypeID) {
									this.resourceDetail.resourceFormat = this.baseService.referenceType('resourceFormat', this.resourceDetail.resourceFormat);
									if (this.resourceDetail.resourceFormat.key === 'link' && !['knowledgecard', 'playlist'].includes(this.resourceDetail.resourceTypeID.key)) {
										if (this.resourceDetail.resource.thumbnail === '') {
											this.resourceDetail.resource.thumbnail = this.resourceDetail.resourceFormat.image;
										}
									}
								}
								if (this.resourceDetail.resource && this.resourceDetail.resource.duration) {
									duration.value = this.resourceDetail.resource.duration;
									// duration.isReadonly = true;
								}
								title.value = this.resourceDetail.title;
								description.value = this.resourceDetail.description;
								if (this.resourceDetail.infoFields) {
									if (this.moocAdd) {
										this.title = this.locale.translate('edit_mooc');
										if (this.resourceDetail.infoFields.authority) {
											authority.value = this.resourceDetail.infoFields.authority;
										}
										if (this.resourceDetail.infoFields.reimbursementApproval) {
											reimbursementApproval.value = [this.resourceDetail.infoFields.reimbursementApproval];
											notes.isHidden = false;
											notes.isReadonly = false;
										}
										if (this.resourceDetail.infoFields.notes) {
											notes.value = this.resourceDetail.infoFields.notes;
										}
									} else if (this.externalEventAdd) {
										this.title = this.locale.translate('edit_external_event');
										if (this.resourceDetail.infoFields.startDate) {
											date.value = new Date(this.resourceDetail.infoFields.startDate);
										}
										if (this.resourceDetail.infoFields.reimbursementApproval) {
											reimbursementApproval.value = [this.resourceDetail.infoFields.reimbursementApproval];
										}
									}
								}
								if (this.resourceDetail.keywords && this.resourceDetail.keywords.length) {
									keywords.selectedValue = this.resourceDetail.keywords.map(resp => {
										return {
											key: resp.ID,
											value: resp.name,
											isDelete: false,
											isAdd: true
										};
									});
									keywords.value = keywords.selectedValue;
								}
								if (this.resourceDetail.authors && this.resourceDetail.authors.length) {
									authors.selectedValue = this.resourceDetail.authors.map(resp => {
										return {
											key: resp.userID,
											value: `${resp.firstName}${resp.lastName
												? ' ' + resp.lastName
												: ''}`,
											prefix: {
												type: 'image',
												value: resp.profilePicURL
											},
											isDelete: false,
											isAdd: true
										};
									});
									authors.value = authors.selectedValue;
								}
								resourceTypeID.value = this.resourceDetail.resourceTypeID.value;
								if (this.action === 'editResource') {
									this.getResourceFields(resourceTypeID.value, this.resourceDetail.infoFields);
									if (this.resourceDetail.linkedResource) {
										this.addSelectedResource(this.resourceDetail.linkedResource);
									}
								}
								if( this.resourceDetail.skills) {
									skills.selectedValue = this.resourceDetail.skills.map(resp => {
										return {
											key: resp.skill.key,
											value: resp.skill.value,
											isDelete: false,
											isAdd: true,
											weightage: resp.skillLevel
										};
									});
									skills.value = skills.selectedValue;
								}
								// if (!uploadFile.isHidden && this.resourceDetail.resource) {
								// 	this.title = this.locale.translate('edit_document');
								// 	uploadFile.value = {
								// 		name: this.resourceDetail.resource.file
								// 	};
								// 	uploadFile.additionalMetaData.thumbnail = this.resourceDetail.resource.thumbnail;
								// }
								// if (!uploadVideo.isHidden && this.resourceDetail.resource) {
								// 	this.title = this.locale.translate('edit_video');
								// 	uploadVideo.value = {
								// 		thumbnail: this.resourceDetail.resource.thumbnail,
								// 		videoFile: this.resourceDetail.resource.file
								// 	};
								// }
								// if (!audioUpload.isHidden && this.resourceDetail.resource) {
								// 	this.title = this.locale.translate('edit_audio');
								// 	audioUpload.value = {
								// 		thumbnail: this.resourceDetail.resource.thumbnail,
								// 		audioFile: this.resourceDetail.resource.file
								// 	};
								// }
								// if (!embed.isHidden && this.resourceDetail.resource) {
								// 	this.title = this.locale.translate('edit_external_link');
								// 	embed.value = {
								// 		link: this.resourceDetail.resource.link,
								// 		title: this.resourceDetail.title,
								// 		description: this.resourceDetail.description,
								// 		image: this.resourceDetail.resource.thumbnail
								// 	};
								// }
								if (!page.isHidden && this.resourceDetail.resource) {
									this.title = this.locale.translate('edit_page');
									page.value = this.resourceDetail.resource.innerHtml
								}
								// if (!imageUpload.isHidden && this.resourceDetail.resource.hasOwnProperty('image')) {
								// 	this.title = this.locale.translate('edit_image');
								// 	const fileValue = [];
								// 	for (const fileObject of this.resourceDetail.resource.image) {
								// 		const finalData: any = {
								// 			file: fileObject.file
								// 		};
								// 		if (fileObject.caption) {
								// 			finalData.caption = fileObject.caption;
								// 		}
								// 		fileValue.push(finalData);
								// 	}
								// 	imageUpload.value = fileValue;
								// }
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								snackBar: {
									position: 'before'
								}
							});
						}
					)
						.add(() => {
							if (this.action === 'editResource') {
								this.formFields = [
									uploadVideo,
									audioUpload,
									uploadFile,
									embed,
									page,
									imageUpload,
									title,
									description,
									authors,
									resourceTypeID
								];
								if (this.resourceFormatData && this.resourceFormatData.key && this.resourceFormatData.key === 'document') {
									this.formFields.splice(8, 0, duration);
								}
								this.linkedResourceField = [linkedResource];
								this.skillField = [skills];
								if (this.moocAdd) {
									embed.fieldPlaceholder = this.locale.translate('paste_mooc_url');
									resourceTypeID.isHidden = true;
									this.resourceFields.push(authority);
									this.skillField.push(reimbursementApproval);
									this.skillField.push(notes);
								} else if (this.externalEventAdd) {
									embed.fieldPlaceholder = this.locale.translate('paste_a_url');
									resourceTypeID.isHidden = true;
									this.resourceFields.push(date);
									this.skillField.push(reimbursementApproval);
									this.skillField.push(notes);
								}
							} else if (this.action === 'editBeadResource') {
								resourceTypeID.isHidden = true;
								keywords.isRequired = true;
								this.formFields = [
									uploadVideo,
									audioUpload,
									uploadFile,
									page,
									imageUpload,
									title,
									description,
									resourceTypeID
								];
								if (this.baseService.checkModuleAccess('M13')){
									this.skillField = [skills];
								}
								if (this.resourceFormatData && this.resourceFormatData.key && this.resourceFormatData.key === 'document') {
									this.formFields.splice(7, 0, duration);
								}
							}
							if (this.resourceType) {
								// this.loadMySkills(skills);
							}
							this.keywordsField = [keywords];
							if (this.helpTriggered) {
								this.loader = false;
							} else {
								this.popupRef.componentInstance.popupLoader = false;
							}
						});
				} else {
					this.formFields = [
						uploadVideo,
						audioUpload,
						uploadFile,
						embed,
						page,
						imageUpload,
						title,
						description,
						authors,
						resourceTypeID
					];
					if (this.resourceFormatData && this.resourceFormatData.key && this.resourceFormatData.key === 'document') {

						this.formFields.splice(8, 0, duration);
					}
					if (this.baseService.checkModuleAccess('M13')){
						this.skillField = [skills];
					}
					if (this.moocAdd) {
						this.title = this.locale.translate('create_mooc')
						embed.fieldPlaceholder = this.locale.translate('paste_mooc_url');
						resourceTypeID.isHidden = true;
						this.resourceFields.push(authority);
						this.skillField.push(reimbursementApproval);
						this.skillField.push(notes);
					} else if (this.externalEventAdd) {
						this.title = this.locale.translate('create_external_event')
						embed.fieldPlaceholder = this.locale.translate('paste_a_url');
						resourceTypeID.isHidden = true;
						this.resourceFields.push(date);
						this.skillField.push(reimbursementApproval);
						this.skillField.push(notes);
					}
					if (this.resourceType) {
						// this.loadMySkills(skills);
					}
					this.loadChannel(channel);
					this.keywordsField = [keywords];
					this.linkedResourceField = [linkedResource];
					this.visibilityField = [channel];
					if (this.helpTriggered) {
						this.loader = false;
					} else {
						this.popupRef.componentInstance.popupLoader = false;
					}
				}
			}
			this.submitDisable = false;
		}
		else if (this.action === 'addScorm' || this.action === 'editScorm') {
			this.title = this.locale.translate('new_scorm_package');
			if (this.action === 'editScorm') {
				this.title = this.locale.translate('edit_scorm');
			}
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			const title: TextBoxModel = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('title'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('content_title')
			};

			const description: TextAreaModel = {
				fieldColumn: 'description',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				validationRegex: null,
				fieldCaption: this.locale.translate('desc'),
				fieldHelpText: null,
				fieldOrder: 3,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('desc')
			};


			const uploadFile: FileUploadModel = {
				fieldCaption: this.locale.translate('upload_file'),
				fieldColumn: 'uploadFile',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 1,
				fieldType: 'fileUpload',
				fieldHelpText: this.locale.translate('upload_supported_file'),
				fieldPlaceholder: this.locale.translate('choose_file'),
				isRequired: true,
				isHidden: false,
				additionalMetaData: {
					showLabel: true,
					fileSize: '1024MB',
					supportedType: ['.zip'],
					drag: true
				},
				isReadonly: false,
				value: null
			};


			if (this.action === 'editScorm') {
				uploadFile.isHidden = true;
				if (this.resourceFormatData) {
					if (this.resourceFormatData.key === 'SCORM') {
						this.currentFieldColumn = uploadFile.fieldColumn;
					}
				}
				const headers: any = {
					lanCode: sessionStorage.getItem('locale') || 'en'
				};

				this.apiService.detail(this.resourceDetail.resourceID, headers).subscribe(
					(response) => {
						if (response) {
							this.resourceDetail = response;
							this.resourceDetail.status = this.baseService.referenceType('resourceStatus', this.resourceDetail.status);
							this.resourceDetail.resourceTypeID = this.baseService.referenceType(
								'resourceType',
								this.resourceDetail.resourceTypeID
							);
							if (this.resourceDetail.resourceFormat && this.resourceDetail.resourceTypeID) {
								this.resourceDetail.resourceFormat = this.baseService.referenceType('resourceFormat', this.resourceDetail.resourceFormat);
							}
							title.value = this.resourceDetail.title;
							description.value = this.resourceDetail.description;
						}
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				)
					.add(() => {
						if (this.action === 'editScorm') {
							this.formFields = [
								title,
								description
							];
						}
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.formFields = [
					title,
					description,
					uploadFile,

				];
				this.submitDisable = false;
				if (this.helpTriggered) {
					this.loader = false;
				} else {
					this.popupRef.componentInstance.popupLoader = false;
				}
			}

			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}

			this.submitDisable = false;
			this.loader = false;
		}
		else if (this.action === 'resourceFormat') {
			this.title = this.locale.translate('new_resource');
			this.loader = true;
			this.resourceFormatList = this.baseService.resourceFormat.filter(item => item.key !== 'scorm');
			// this.resourceFormatList.push(
			// 	{
			// 		title: this.locale.translate('video'),
			// 		type: 'video',
			// 		resourceFormat: 2,
			// 		svgIcon: 'video_camera'
			// 	},
			// 	{
			// 		title: this.locale.translate('audio'),
			// 		type: 'audio',
			// 		resourceFormat: 3,
			// 		svgIcon: 'audio_headphone'
			// 	},
			// 	{
			// 		title: this.locale.translate('document'),
			// 		type: 'document',
			// 		resourceFormat: 1,
			// 		svgIcon: 'document'
			// 	},
			// 	{
			// 		title: this.locale.translate('external_link'),
			// 		type: 'link',
			// 		resourceFormat: 5,
			// 		svgIcon: 'external_link'
			// 	},
			// 	{
			// 		title: this.locale.translate('page'),
			// 		type: 'page',
			// 		resourceFormat: 4,
			// 		svgIcon: 'pages'
			// 	},
			// 	{
			// 		title: this.locale.translate('image'),
			// 		type: 'image',
			// 		resourceFormat: 6,
			// 		svgIcon: 'document'
			// 	}
			// );
			this.loader = false;
		} else if (this.action === 'forwardResource') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.title = this.locale.translate('forward');
			const forwardTo: AutoCompleteModel = {
				fieldColumn: 'forwardTo',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('forward_to'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('users_and_workgroups')
			};

			this.formFields = [forwardTo];
			this.submitDisable = false;
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}
		} else if (this.action === 'reject') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('reject');
			this.info = this.locale.translate('resource_reject_help_text')
			const policyDeviation: CheckBoxModel = {
				fieldColumn: 'policyDeviation',
				additionalMetaData: {
					showLabel: true,
					min: 1
				},
				fieldType: 'checkBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				fieldCaption: this.locale.translate('policy_deviation'),
				fieldOrder: 1
			};
			const remark: TextAreaModel = {
				fieldColumn: 'remark',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('remarks'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('remarks')
			};
			const apiData = {
				termsetid: 14
			};
			const headers: any = {};
			this.globalApiService.getTerm(apiData, headers).subscribe(
				(response) => {
					if (response && response.records.length) {
						policyDeviation.options = response.records.map(resp => {
							return {
								key: resp.termID,
								value: resp.term
							};
						});
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.formFields = [policyDeviation, remark];
					this.submitDisable = false;
					this.popupRef.componentInstance.popupLoader = false;
				});
		} else if (this.action === 'guideline') {
			this.title = this.locale.translate('guidelines');
			this.info = this.locale.translate('moderation_guideline_text');
		} else if (this.action === 'settings') {
			this.title = this.locale.translate('settings');
			this.popupRef.componentInstance.popupLoader = true;
			const apiData = {};
			const headers: any = {};
			this.apiService.getSettings(apiData, this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					if (response) {
						this.settingsData = response;
						this.tabChange(this.tabIndex);
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.popupRef.componentInstance.popupLoader = false;
					this.submitDisable = false;
				});
			this.tabChange(this.tabIndex);
		} else if (this.action === 'viewImage') {
			this.title = '';
			if (this.imageIndex) {
				this.mainSlider.startPosition = this.imageIndex;
			}
			if (this.resourceDetail) {
				if (this.resourceDetail.resource.hasOwnProperty('image')) {
					this.imageList = this.resourceDetail.resource.image;
				}
			}
		} else if (this.action === 'editImageResource') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}

			const imageUpload: ImageUploadModel = {
				fieldCaption: this.locale.translate('cover_image'),
				fieldColumn: 'imageUpload',
				validationMessage: this.locale.translate('invalid_file'),
				fieldOrder: 1,
				fieldType: 'imageUpload',
				fieldHelpText: null,
				fieldPlaceholder: this.locale.translate('drop_click_image_upload'),
				isRequired: true,
				isHidden: false,
				additionalMetaData: {
					showLabel: false,
					fileSize: '10MB',
					supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
					max: 20
				},
				isReadonly: false,
				value: null
			};

			const headers: any = {
				lanCode: sessionStorage.getItem('locale') || 'en'
			};
			this.apiService.detail(this.resourceDetail.resourceID, headers).subscribe(
				(response) => {
					if (response) {
						this.resourceDetail = response;

						if (!imageUpload.isHidden && this.resourceDetail.resource.hasOwnProperty('image')) {
							this.title = this.locale.translate('edit_image');
							const fileValue = [];
							for (const fileObject of this.resourceDetail.resource.image) {
								const finalData: any = {
									file: fileObject.file
								};
								if (fileObject.caption) {
									finalData.caption = fileObject.caption;
								}
								fileValue.push(finalData);
							}
							imageUpload.value = fileValue;
						}
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.formFields = [
						imageUpload
					];
					if (this.helpTriggered) {
						this.loader = false;
					} else {
						this.popupRef.componentInstance.popupLoader = false;
					}
					this.submitDisable = false;
				});

		} else if (this.action === 'makePublic') {
			this.title = this.locale.translate('make_public');
			const tagUser: AutoCompleteModel = {
				fieldColumn: 'taggedUsers',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('tag_your_managers_supervisors'),
				fieldOrder: 3,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_users'),
				type: 'general'
			};
			this.formFields = [tagUser];
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}
			this.submitDisable = false;
		} else if (this.action === 'resourceFilter') {
			this.title = this.locale.translate('category');
			this.loader = false;
		}

	}

	loadChannel(channelField) {
		channelField.options = [];
		const apiData = {};
		const headers: any = {};

		let selectedValue = [];
		if (channelField.selectedValue.length) {
			channelField.selectedValue.map(items => {
				if (items.isAdd && !items.isDelete) {
					selectedValue.push(items.key);
				}
			});
		}
		this.channelsApiService.getChannelList(apiData, headers).subscribe(
			(response) => {
				if (response && response.records.length) {
					if (selectedValue.length) {
						response.records = response.records.filter(items => {
							if (!selectedValue.includes(items.channelID)) {
								return items;
							}
						});
					}
					channelField.options = response.records.map((data) => {
						return {
							key: data.channelID,
							value: data.channelName
						};
					});
				}

			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		);
	}

	tabChange(index, changeLoader = false) {
		this.tabIndex = index;
		if (changeLoader) {
			this.loader = true;
		}
		if (index === 0) {
			const commenting: DropDownModel = {
				fieldCaption: this.locale.translate('conversations'),
				fieldColumn: 'commenting',
				validationMessage: '',
				fieldOrder: 1,
				fieldType: 'dropDown',
				fieldHelpText: '',
				isRequired: false,
				isHidden: false,
				additionalMetaData: {},
				options: [],
				isReadonly: false,
				value: null,
				isMultiple: false
			};
			const allowRating: CheckBoxModel = {
				fieldColumn: 'rating',
				additionalMetaData: {
					showLabel: true
				},
				fieldType: 'checkBox',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				options: [{
					key: true,
					value: this.locale.translate('allow_rating')
				}],
				fieldCaption: null,
				fieldOrder: 2
			};
			// const flagging: CheckBoxModel = {
			// 	fieldColumn: 'flagging',
			// 	additionalMetaData: {
			// 		showLabel: true
			// 	},
			// 	fieldType: 'checkBox',
			// 	isHidden: false,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [{
			// 		key: true,
			// 		value: this.locale.translate('allow_flagging')
			// 	}],
			// 	fieldCaption: null,
			// 	fieldOrder: 3
			// };
			commenting.options = [
				{
					key: 'show',
					value: this.locale.translate('enable_conversations')
				},
				{
					key: 'inactive',
					value: this.locale.translate('disable_conversations')
				},
				{
					key: 'hide',
					value: this.locale.translate('hide_conversations')
				}
			];
			if (this.settingsData) {
				if (this.settingsData.rating) {
					allowRating.value = [this.settingsData.rating];
				}
				// if (this.settingsData.flagging) {
				// 	flagging.value = [this.settingsData.flagging];
				// }
				if (this.settingsData.commenting) {
					commenting.value = this.settingsData.commenting;
				}
			}
			this.formFields = [
				commenting,
				allowRating,
				// flagging
			];
			if (changeLoader) {
				this.loader = false;
			}
		} else if (index === 1) {
			// const departments: AutoCompleteModel = {
			// 	fieldColumn: 'departments',
			// 	additionalMetaData: {
			// 		showLabel: true,
			// 		autoFill: 'off',
			// 		max: 1
			// 	},
			// 	fieldType: 'autoComplete',
			// 	isHidden: false,
			// 	isMultiple: true,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [],
			// 	selectedValue: [],
			// 	fieldCaption: this.locale.translate('departments'),
			// 	fieldOrder: 1,
			// 	preDefined: true,
			// 	fieldPlaceholder: this.locale.translate('departments')
			// };
			// const functionalRoles: AutoCompleteModel = {
			// 	fieldColumn: 'functionalRoles',
			// 	additionalMetaData: {
			// 		showLabel: true,
			// 		autoFill: 'off'
			// 	},
			// 	fieldType: 'autoComplete',
			// 	isHidden: false,
			// 	isMultiple: true,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [],
			// 	selectedValue: [],
			// 	fieldCaption: this.locale.translate('functional_roles'),
			// 	fieldOrder: 2,
			// 	preDefined: true,
			// 	fieldPlaceholder: this.locale.translate('functional_roles')
			// };
			// const countries: AutoCompleteModel = {
			// 	fieldColumn: 'countries',
			// 	additionalMetaData: {
			// 		showLabel: true,
			// 		autoFill: 'off',
			// 		max: 1
			// 	},
			// 	fieldType: 'autoComplete',
			// 	isHidden: false,
			// 	isMultiple: true,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [],
			// 	selectedValue: [],
			// 	fieldCaption: this.locale.translate('countries'),
			// 	fieldOrder: 3,
			// 	preDefined: true,
			// 	fieldPlaceholder: this.locale.translate('countries')
			// };
			const channel: AutoCompleteModel = {
				fieldColumn: 'channel',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('channels'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_channels')
			};
			this.loadChannel(channel);
			if (this.settingsData && this.settingsData.visibility) {
				if (this.settingsData.visibility.channel && this.settingsData.visibility.channel.length) {
					channel.value = this.settingsData.visibility.channel.map(data => {
						return {
							key: data.ID,
							value: data.name,
							isAdd: true,
							isDelete: false
						};
					});
					channel.selectedValue = channel.value;
				}
				// if (this.settingsData.visibility.department && this.settingsData.visibility.department.length) {
				// 	departments.value = [
				// 		{
				// 			key: this.settingsData.visibility.department[0].ID,
				// 			value: this.settingsData.visibility.department[0].name,
				// 			isAdd: true,
				// 			isDelete: false
				// 		}
				// 	];
				// 	departments.selectedValue = departments.value;
				// }
				// if (this.settingsData.visibility.functionalRole && this.settingsData.visibility.functionalRole.length) {
				// 	functionalRoles.value = this.settingsData.visibility.functionalRole.map(resp => {
				// 		return {
				// 			key: resp.ID,
				// 			value: resp.name,
				// 			isAdd: true,
				// 			isDelete: false
				// 		};
				// 	});
				// 	functionalRoles.selectedValue = functionalRoles.value;
				// }
			}
			this.formFields = [
				channel
			];
			if (changeLoader) {
				this.loader = false;
			}
		} else if (index === 2) {
			this.infoTabData = [];
			if (this.resourceDetail) {
				if (this.resourceDetail.createdAt) {
					this.infoTabData.push(
						{
							type: 'text',
							label: this.locale.translate('created_on'),
							value: this.gfService.dateFormat(this.resourceDetail.createdAt, 'MMM d, y')
						}
					);
				}
				if (this.resourceDetail.lastUpdatedAt) {
					this.infoTabData.push(
						{
							type: 'text',
							label: this.locale.translate('last_edited_on'),
							value: this.gfService.dateFormat(this.resourceDetail.lastUpdatedAt, 'MMM d, y')
						}
					);
				}
			}
		}
	}

	searchPeopleDetail(userID) {
		if (userID) {
			this.baseService.userDetail(userID);
		}
	}

	resourceObjectReader(record: any) {
		this.resourceFormObject = record;
	}

	keywordsFormReader(record: any) {
		if (!this.keywordsFormObject) {
			let subscribe;
			const keywords = this.keywordsField.find((items) => items.fieldColumn === 'keywords');
			const form: UntypedFormGroup = record.form;
			form.controls.keywords.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 13
							};
							const header: any = {
								lanCode: sessionStorage.getItem('locale') || 'en'
							};
							let selectedValue = [];
							if (keywords.selectedValue.length) {
								keywords.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										keywords.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										keywords.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									keywords.options = [];
								}
							);
						} else {
							keywords.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		this.keywordsFormObject = record;
	}

	makePublicFormObjectReader(record: any) {
		if (!this.makePublicFormObject) {
			let subscribe;
			const tagUser = this.formFields.find((items) => items.fieldColumn === 'taggedUsers');
			const form: UntypedFormGroup = record.form;
			form.controls.taggedUsers.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (tagUser.selectedValue.length) {
								tagUser.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getUsers(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.userID)) {
													return items;
												}
											});
										}
										tagUser.options = response.records.map((data) => {
											return {
												key: data.userID,
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										});
									} else {
										tagUser.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									tagUser.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								tagUser.options = [];
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		this.makePublicFormObject = record;
	}

	loadMySkills(skills) {
		const apiData = {};
		const headers: any = {};
		skills.options = [];
		this.globalApiService.getMySkills(apiData, headers).subscribe(
			(response) => {
				if (response && Array.isArray(response.records)) {
					skills.options = response.records.map(resp => {
						return {
							key: resp.skill,
							value: resp.skillName
						};
					});
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
			});
	}

	skillFormReader(record: any) {
		if (!this.skillFormObject) {
			let subscribe;
			const skills = this.skillField.find((items) => items.fieldColumn === 'skills');
			const form: UntypedFormGroup = record.form;
			form.controls.skills.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 1
							};
							const header: any = {};
							let selectedValue = [];
							if (skills.selectedValue.length) {
								skills.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										skills.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										skills.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									skills.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								skills.options = [];
							} else {
								if (this.resourceType) {
									// this.loadMySkills(skills);
								}
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
			if (form.controls.reimbursementApproval) {
				form.controls.reimbursementApproval.valueChanges.subscribe(controlResp => {
					if (controlResp && Array.isArray(controlResp)) {
						const notes = this.skillField.find(items => items.fieldColumn === 'notes');
						if (controlResp[0]) {
							form.controls.notes.enable({ emitEvent: false });
							form.controls.notes.patchValue(null, { emitEvent: false });
							notes.isHidden = false;
							notes.isReadonly = false;
						} else {
							form.controls.notes.disable({ emitEvent: false });
							form.controls.notes.patchValue(null, { emitEvent: false });
							notes.isHidden = true;
							notes.isReadonly = true;
						}
					}
				});
			}
		}
		this.skillFormObject = record;
	}

	formObjectReader(record: any) {
		this.form = record.form;
		this.formObject = record;
		if (record.form.controls.embed) {
			record.form.controls.embed.valueChanges.subscribe((embedData) => {
				if (navigator.onLine) {
					if (embedData && typeof embedData === 'object') {
						record.form.controls.title.patchValue(embedData.title, { emitEvent: false });
						record.form.controls.description.patchValue(embedData.description, { emitEvent: false });
						record.form.controls.description.markAsTouched();
						record.form.controls.title.markAsTouched();
						if (this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.authority) {
							let patchValue;
							const link = new URL(embedData.link);
							patchValue = link.hostname.split('.');
							if (link.hostname && link.hostname.split('.').length) {
								patchValue = link.hostname.split('.')[1];
							}
							this.formObjectData.form.controls.authority.patchValue(patchValue, { emitEvent: false });
						}
					} else {
						record.form.controls.title.patchValue(null, { emitEvent: false });
						record.form.controls.description.patchValue(null, { emitEvent: false });
					}
				}
			});
		}
		if (this.form.controls.resourceTypeID) {
			this.form.controls.resourceTypeID.valueChanges.subscribe((controlResp) => {
				if (controlResp && navigator.onLine) {
					this.getResourceFields(controlResp);
				}
			});
		}
		if (this.form.controls.authors) {
			let subscribe;
			const authorsField = this.formFields.find((items) => items.fieldColumn === 'authors');
			this.form.controls.authors.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								includeCurrentUser: 1
							};
							const header: any = {};
							let selectedValue = [];
							if (authorsField.selectedValue.length) {
								authorsField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getUsers(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.userID)) {
													return items;
												}
											});
										}
										authorsField.options = response.records.map((data) => {
											return {
												key: data.userID,
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										});
									} else {
										authorsField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									authorsField.options = [];
								}
							);
						} else {
							authorsField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (this.form.controls.linkedResource) {
			let subscribe;
			const linkedResourceField = record.fields.find((items) => items.fieldColumn === 'linkedResource');
			this.form.controls.linkedResource.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					if (controlResp && typeof controlResp === 'object') {
						if (controlResp.isAdd) {
							this.addSelectedResource([controlResp.key]);
						}
						linkedResourceField.selectedValue = [];
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							let selectedValue = [];
							this.selectedResources.map(items => {
								selectedValue.push(items.resourceID);
							});
							const apiData = {
								searchString: controlResp
							};
							const header: any = {
								lanCode: sessionStorage.getItem('locale') || 'en'
							};
							subscribe = this.globalApiService.searchByResource(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										response.records = response.records.filter(items => {
											if (!selectedValue.includes(items.resourceID)) {
												return items;
											}
										});
										linkedResourceField.options = [];
										for (const record of response.records) {
											linkedResourceField.options.push(
												{
													key: record,
													value: record.title
												}
											);
										}
									} else {
										linkedResourceField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									linkedResourceField.options = [];
								}
							);
						} else {
							linkedResourceField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (this.form.controls.departments) {
			let subscribe;
			const departmentsField = record.fields.find((items) => items.fieldColumn === 'departments');
			this.form.controls.departments.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 7

							};
							const header: any = {};
							let selectedValue = [];
							if (departmentsField.selectedValue.length) {
								departmentsField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										departmentsField.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										departmentsField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									departmentsField.options = [];
								}
							);
						} else {
							departmentsField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (this.form.controls.functionalRoles) {
			let subscribe;
			const functionalRolesField = record.fields.find((items) => items.fieldColumn === 'functionalRoles');
			this.form.controls.functionalRoles.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 4

							};
							const header: any = {};
							let selectedValue = [];
							if (functionalRolesField.selectedValue.length) {
								functionalRolesField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										functionalRolesField.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										functionalRolesField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									functionalRolesField.options = [];
								}
							);
						} else {
							functionalRolesField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (this.form.controls.countries) {
			let subscribe;
			const countriesField = record.fields.find((items) => items.fieldColumn === 'countries');
			this.form.controls.countries.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 8

							};
							const header: any = {};
							let selectedValue = [];
							if (countriesField.selectedValue.length) {
								countriesField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.key)) {
													return items;
												}
											});
										}
										countriesField.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										countriesField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									countriesField.options = [];
								}
							);
						} else {
							countriesField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (this.form.controls.channel) {
			let subscribe;
			const channelField = record.fields.find((items) => items.fieldColumn === 'channel');
			this.form.controls.channel.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp
							};
							const header: any = {};
							let selectedValue = [];
							if (channelField.selectedValue.length) {
								channelField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.channelsApiService.getChannelList(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.channelID)) {
													return items;
												}
											});
										}
										channelField.options = response.records.map((data) => {
											return {
												key: data.channelID,
												value: data.channelName
											};
										});
									} else {
										channelField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									channelField.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								channelField.options = [];
							} else {
								this.loadChannel(channelField);
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (this.form.controls.uploadFile) {
			this.form.controls.uploadFile.valueChanges.subscribe(async (controlResp) => {
				if (this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls.duration) {
					if (controlResp) {
						if ([null, undefined].includes(this.formObjectData.form.controls.duration.value)) {
							const fileExt = controlResp.name.split('.')[1].toLowerCase();
							let totalWordCount: any = 0;
							if (['pdf'].includes(fileExt)) {
								this.documentLoader = true;
								totalWordCount = await this.readPdfFile(controlResp);
								this.documentLoader = false;
								const duration = this.gfService.getEstimatedReadingTime(totalWordCount, 'hh:mm');
								this.formObjectData.form.controls.duration.patchValue(duration);
							}
						}
					} else {
						this.formObjectData.form.controls.duration.patchValue(null);
					}
				}
			});
		}
	}

	addSelectedResource(resources) {
		for (const resource of resources) {

			let finalData: any = {};
			if (resource.resourceTypeID) {
				resource.resourceType = this.baseService.referenceType('resourceType', resource.resourceTypeID);
				if (resource.resourceType.key === 'answer') {
					const cardData: QuestionCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						thumbnail: '',
						removable: true
					};
					// if (data.authors && data.authors.length) {
					// 	cardData.thumbnail = data.authors[0].profilePicURL;
					// 	cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
					// 		? ' ' + data.authors[0].lastName
					// 		: ''}`;
					// 	if (data.authors.length > 1) {
					// 		cardData.usersCount = (data.authors.length - 1);
					// 	}
					// }

					finalData = cardData;
				} else if (resource.resourceType.key === 'playlist') {
					const cardData: PlaylistCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
						// type: resource.resourceType.caption,
						thumbnail: '',
						removable: true
						// playlistItemCount: data.count
					};

					finalData = cardData;
				} else if (['internalEvent', 'externalEvent'].includes(resource.resourceType.key)) {
					const cardData: EventCard = {
						thumbnail: '',
						title: resource.title,
						eventType: (resource.resourceType && resource.resourceType.key) ? resource.resourceType.key : null,
						removable: true
					};
					if (resource.resourceType) {
						// if (data.infoFields) {
						// 	if (data.resourceType.key === 'internalEvent') {
						// 		if (data.infoFields.time) {
						// 			cardData.time = this.gfService.dateFormat(data.infoFields.time, 'shortTime');
						// 		}
						// 		if (data.infoFields.date.length) {
						// 			cardData.date = `${this.gfService.dateFormat(data.infoFields.date[0], 'd')} ${this.gfService.dateFormat(data.infoFields.date[0], 'MMM')} - ${this.gfService.dateFormat(data.infoFields.date[1], 'd')} ${this.gfService.dateFormat(data.infoFields.date[1], 'MMM')}`;
						// 		}
						// 	} else {
						// 		if (data.infoFields.date) {
						// 			cardData.date = this.gfService.dateFormat(data.infoFields.date, 'd MMM');
						// 		}
						// 	}
						// }
					}

					finalData = cardData;
				} else {
					const cardData: ContentImageCard = {
						title: resource.title,
						// date: this.gfService.dateFormat(resource.createdAt, 'MMM d, y'),
						thumbnail: '',
						removable: true
					};
					finalData = cardData;

				}

				finalData.type = resource.resourceType.caption;
			}

			if (resource.resource.hasOwnProperty('duration')) {
				finalData.duration = resource.resource.duration;
			}

			// if (resource.description) {
			// 	cardData.description = resource.description;
			// 	}
			if (resource.resource && resource.resource.thumbnail && resource.resourceType && resource.resourceType.key !== 'answer') {
				finalData.thumbnail = resource.resource.thumbnail;
			}
			if (resource.resourceFormat) {
				resource.resourceFormat = this.baseService.referenceType('resourceFormat', resource.resourceFormat);
				finalData.format = resource.resourceFormat.key;
				if (finalData.thumbnail === '') {
					finalData.thumbnail = resource.resourceFormat.image;
				}
			}

			const extraData = {
				resourceID: resource.resourceID,
				createdBy: resource.createdBy
			};
			this.selectedResources.push(this.gfService.JSONMerge(finalData, extraData));
		}
		if (this.selectedResources && this.selectedResources.length >= 10 && this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.linkedResource) {
			this.formObjectData.form.controls.linkedResource.disable({ emitEvent: false });
		}
	}

	removeResource(index) {
		if (navigator.onLine) {
			this.selectedResources.splice(index, 1);
			if (this.selectedResources && this.selectedResources.length < 10 && this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.linkedResource && this.formObjectData.form.controls.linkedResource.disabled) {
				this.formObjectData.form.controls.linkedResource.enable({ emitEvent: false });
			}
		}
	}

	forwardFormObject(record: any) {
		this.formObject = record;
		const form: UntypedFormGroup = this.formObject.form;
		if (this.action === 'forwardResource') {
			let subscribe;
			const userField = this.formFields.find((items) => items.fieldColumn === 'forwardTo');

			form.controls.forwardTo.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData: any = {
								searchString: controlResp,
								includeWorkGroup: 1
							};
							const header: any = {};
							let selectedUser = [];
							if (userField.selectedValue.length) {
								userField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete && !items.key.isWorkGroup) {
										selectedUser.push(items.key.ID);
									}
								});
							}
							let selectedWorkgroup = [];
							if (userField.selectedValue.length) {
								userField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete && items.key.isWorkGroup) {
										selectedWorkgroup.push(items.key.ID);
									}
								});
							}
							if (this.resourceDetail && this.resourceDetail.authors && this.resourceDetail.authors.length) {
								for (const author of this.resourceDetail.authors) {
									selectedUser.push(author.userID);
								}
							}
							subscribe = this.globalApiService.getUsers(apiData, header).subscribe(
								(response) => {
									if (response) {
										if (selectedUser.length) {
											response.records = response.records.filter(items => {
												if (!selectedUser.includes(items.userID)) {
													return items;
												}
											});
										}
										if (selectedWorkgroup.length) {
											if (response.workgroup && response.workgroup.length) {
												response.workgroup = response.workgroup.filter(items => {
													if (!selectedWorkgroup.includes(items.groupID)) {
														return items;
													}
												});
											}
										}
										let options = [];
										if (response.workgroup && response.workgroup.length) {
											options = response.workgroup.map((data) => {
												return {
													key: {
														ID: data.groupID,
														isWorkGroup: true
													},
													value: data.groupName,
													prefix: {
														type: 'svgIcon',
														value: 'workgroup'
													}
												};
											});
										}
										options = options.concat(response.records.map((data) => {
											return {
												key: {
													ID: data.userID,
													isWorkGroup: false
												},
												value: `${data.firstName}${data.lastName
													? ' ' + data.lastName
													: ''}`,
												prefix: {
													type: 'image',
													value: data.profilePicURL
												},
												shortInfo: this.baseService.getUserShortInfo(data)
											};
										}));
										userField.options = options;
									} else {
										userField.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									userField.options = [];
								}
							);
						} else {
							userField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	getResourceFields(resource: any, fieldValue = {}) {
		if (this.helpTriggered) {
			this.loader = true;
		} else {
			this.popupRef.componentInstance.popupLoader = true;
		}
		this.resourceFields = [];
		this.resourceFormObject = null;
		const headers: any = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.apiService
			.getResource(resource, headers)
			.subscribe(
				(response) => {
					if (response && response.length) {
						this.resourceFields = this.fieldValueBuild(response, fieldValue);
						const authority = this.resourceFields.find(items => items.fieldColumn === 'authority');
						if (authority && this.formObjectData && this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls.embed) {
							const embedData = this.formObjectData.form.controls.embed.value;
							if (embedData) {
								let patchValue;
								const link = new URL(embedData.link);
								patchValue = link.hostname.split('.');
								if (link.hostname && link.hostname.split('.').length) {
									patchValue = link.hostname.split('.')[1];
								}
								authority.value = patchValue;
							}
						}
					} else {
						// this.submitDisable = true;
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
			.add(() => {
				this.submitDisable = false;
				if (this.helpTriggered) {
					this.loader = false;
				} else {
					this.popupRef.componentInstance.popupLoader = false;
				}
			});
	}

	fieldValueBuild(fieldData, fieldValue) {
		let fields = [];
		for (const data of fieldData) {
			if (Object.keys(fieldValue).length > 0) {

				Object.keys(fieldValue).forEach((key, index) => {

					if (data.fieldColumn === key) {

						if (data.fieldType === 'textBox') {
							data.value = fieldValue[key];
						} else if (data.fieldType === 'owlDate') {
							data.value = new Date(fieldValue[key]);
						}
					}
				})

			}
			fields.push(data);
		}
		return fields;
	}



	submit(data: any = null) {

		if (navigator.onLine) {
			if (['addResource', 'editResource', 'editBeadResource'].includes(this.action)) {
				this.createResource();
			} else if (this.action === 'addScorm' || this.action === 'editScorm') {
				this.createScorm();
			} else if (this.action === 'resourceFormat') {
				// this.popupRef.close(data);
				this.addResource('addResource', data);

			} else if (this.action === 'forwardResource') {
				this.saveForwardResource()
			} else if (this.action === 'reject') {
				this.reject();
			} else if (this.action === 'settings') {
				this.updateGeneralSettings();
			} else if (this.action === 'editImageResource') {
				this.updateImageResource()
			} else if (this.action === 'makePublic') {
				this.makePublic();
			}
		}
	}

	updateImageResource() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('editImageResourceAlert');
			if (this.formObjectData.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const headers: any = {};
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);

				const apiValue: any = {};

				let formData;
				if (this.resourceFormatData.key === 'image' && formValue.imageUpload) {
					let caption = [];
					let existingImage = {
						image: []
					};
					formValue.imageUpload.map((imageValue, index) => {
						if (imageValue.file instanceof File && !imageValue.removed) {
							let pushData = imageValue.caption;
							if (!pushData) {
								pushData = '';
							}
							caption.push(pushData);
						} else {
							existingImage.image.push({
								file: imageValue.file,
								caption: (imageValue.caption ? imageValue.caption : null),
								removed: imageValue.removed
							})
						}
					});
					if (existingImage.image.length > 0) {
						apiValue.resource = existingImage;
					}

					apiValue.caption = caption;
				}
				apiValue.resourceFormat = this.resourceDetail.resourceFormat;
				formData = this.gfService.convertToFormData(apiValue);
				const imageData = [];
				if (formValue.imageUpload && Array.isArray(formValue.imageUpload) && formValue.imageUpload.length) {
					formValue.imageUpload.map(async (resp) => {
						if (resp.file instanceof File) {
							formData.append('image', resp.file);
							const file = await this.gfService.fileToDataURL(resp.file);
							imageData.push({
								file,
								caption: resp.caption || null
							});
						} else if (!resp.removed) {
							imageData.push({
								file: resp.file,
								caption: resp.caption || null
							});
						}
					});
				}

				this.apiService
					.updateResource(formData, this.resourceDetail.resourceID, headers)
					.subscribe(
						async (response) => {
							if (response) {
								this.popupRef.close({ imageData });
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('resource_image_updated'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							this.gfService.alertHandler(error, 'editImageResourceAlert', 'ERROR');
							this.gfService.formErrorHandler(error, this.formObjectData.form);
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	saveForwardResource() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('forwardResourceAlert');
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const UserIds = [];
				for (const data of formData.forwardTo) {
					if (data.isAdd && !data.isDelete && !data.key.isWorkGroup) {
						UserIds.push(data.key.ID);
					}
				}
				const workgroupID = [];
				for (const data of formData.forwardTo) {
					if (data.isAdd && !data.isDelete && data.key.isWorkGroup) {
						workgroupID.push(data.key.ID);
					}
				}
				const apiData = {
					toUserID: UserIds,
					workgroup: workgroupID,
					notificationType: 1
				};
				if (this.deviceDetails.browserName === 'Safari') {
					apiData.notificationType = 2;
				}
				this.apiService
					.saveForwardResource(apiData, this.resourceDetail.resourceID, headers)
					.subscribe(
						(response) => {
							this.baseService.logUserActivity('forward', 'engagement', [''], { resourceData: this.resourceDetail });
							this.popupRef.close(apiData);
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate('resource_forwarded'),
								icon: 'check_circle_outline',
								position: 'before'
							});
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'EMPTY_USERID_OR_WORKGROUPID') {
								error.error = this.locale.translate('workgroup_has_no_users');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'forwardResourceAlert'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	addResource(action: string, data: any = null) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: action
					},
					{
						variableName: 'resourceFormatData',
						value: data
					},
					{
						variableName: 'resourceType',
						value: this.resourceType
					}
				]
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (action === 'addResource') {
					let finalResult;
					if (this.actionFrom === 'courseActivity') {
						result.resourceID = result.recordID;
						result.createdBy = this.currentUser.userID;
						this.resourceList.push(result);
						finalResult = this.resourceList;
					} else {
						finalResult = result;
					}
					// this.addResource('addResource', result);
					this.popupRef.componentInstance.dialogCloseData = finalResult;
					// this.popupRef.close(result);
				}
			}
		});

	}

	async createResource() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('addResourceAlert');
			const resourceFormValid = (this.resourceFormObject) ? this.resourceFormObject.form.valid : true;

			if (this.formObjectData.form.valid && resourceFormValid || this.skillFormObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const headers: any = {};
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				let resourceFormValue;
				if (this.resourceFormObject && this.resourceFormObject.fields && this.resourceFormObject.fields.length) {
					resourceFormValue = this.gfService.fieldSubmitApiValueConstruct(
						this.resourceFormObject.form.getRawValue(),
						this.resourceFormObject.fields
					);
				}
				let skillFormValue 
				if (![undefined, null, ''].includes(this.skillFormObject)) {
					skillFormValue = this.gfService.fieldSubmitApiValueConstruct(
						this.skillFormObject.form.getRawValue(),
						this.skillFormObject.fields
					);
				}
				

				const skills = [];
				if(![undefined, null, ''].includes(skillFormValue)) {
					for (const skill of skillFormValue.skills) {
						if (!skill.value && skill.isAdd && !skill.isDelete) {
							skills.push({
								skill: skill.key,
								skillLevel: skill.progress
							});
						} else if (skill.value) {
							if (skill.value.isAdd && !skill.value.isDelete) {
								const skillData: any = { skillName: skill.value.value };
								if (skill.value.progress) {
									skillData.skillLevel = skill.value.progress;
								}
								skills.push(skillData);
							}
						}
					}
				}
				

				const keywordsFormValue = this.gfService.fieldSubmitApiValueConstruct(
					this.keywordsFormObject.form.getRawValue(),
					this.keywordsFormObject.fields
				);

				const keywords = [];
				if (keywordsFormValue && keywordsFormValue.keywords) {
					for (const keyword of keywordsFormValue.keywords) {
						if (keyword.hasOwnProperty('value')) {
							if (keyword.value.isAdd && !keyword.value.isDelete) {
								keywords.push(keyword.value.value);
							}
						} else {
							if (keyword.isAdd && !keyword.isDelete) {
								keywords.push(keyword.key);
							}
						}

					}
				}
				const authors = [];
				if (formValue.authors) {
					for (const author of formValue.authors) {
						if (author.hasOwnProperty('key')) {
							if (author.isAdd && !author.isDelete) {
								if (author.key) {
									authors.push({
										id: author.key
									})
								}
							}
						} else {
							if (author.value.isAdd && !author.value.isDelete) {
								authors.push({
									Name: author.value.value
								});
							}
						}
					}
				}
				const data: any = {
					title: formValue.title,
					description: formValue.description,
					resourceTypeID: formValue.resourceTypeID,
					// infoFields: (resourceFormValue) ? resourceFormValue : null,
					languageCode: this.languageCode,
					skills,
					// authors,
					keywords
				};

				if (this.action === 'editBeadResource') {
					delete data.resourceTypeID;
				}

				if (this.moocAdd) {
					data.resourceTypeID = this.baseService.resourceType.find(items => items.key === 'mooc').value;
				}
				if (this.externalEventAdd) {
					data.resourceTypeID = this.baseService.resourceType.find(items => items.key === 'externalEvent').value;
				}
				if (resourceFormValue) {
					// if (resourceFormValue.date) {
					// 	resourceFormValue.date = Date.parse(resourceFormValue.date);
					// }
					data.infoFields = resourceFormValue;
					if (resourceFormValue.startDate) {
						data.expiryDate = resourceFormValue.startDate;
					}
				}
				
				if (skillFormValue && Array.isArray(skillFormValue.reimbursementApproval) && data.infoFields) {
					if (skillFormValue.reimbursementApproval[0] !== null) {
						data.infoFields.reimbursementApproval = skillFormValue.reimbursementApproval[0];
					} else {
						data.infoFields.reimbursementApproval = false;
					}
				}

				if (skillFormValue && skillFormValue.notes && data.infoFields) {
					data.infoFields.notes = skillFormValue.notes;
				}

				if (authors.length > 0) {
					data.authors = authors;
				} else if (this.action === 'editResource') {
					data.authors = [];
				}
				const visibility: any = {};
				if (formValue.channel) {
					const channelsID = [];
					for (const channel of formValue.channel) {
						if (channel.isAdd && !channel.isDelete) {
							channelsID.push(channel.key);
						}
					}
					if (channelsID.length > 0) {
						visibility.channel = channelsID;
					}
				}
				delete formValue.channel;
				// if (formValue.countries) {
				// 	const countriesID = [];
				// 	for (const country of formValue.countries) {
				// 		if (country.isAdd && !country.isDelete) {
				// 			countriesID.push(country.key);
				// 		}
				// 	}
				// 	if (countriesID.length > 0) {
				// 		visibility.country = countriesID;
				// 	}
				// }
				// if (formValue.departments) {
				// 	const departmentsID = [];
				// 	for (const department of formValue.departments) {
				// 		if (department.isAdd && !department.isDelete) {
				// 			departmentsID.push(department.key);
				// 		}
				// 	}
				// 	if (departmentsID.length > 0) {
				// 		visibility.department = departmentsID;
				// 	}
				// }
				// if (formValue.functionalRoles) {
				// 	const functionalRolesID = [];
				// 	for (const role of formValue.functionalRoles) {
				// 		if (role.isAdd && !role.isDelete) {
				// 			functionalRolesID.push(role.key);
				// 		}
				// 	}
				// 	if (functionalRolesID.length > 0) {
				// 		visibility.functionalRole = functionalRolesID;
				// 	}
				// }

				if (this.selectedResources.length > 0) {
					const linkedResources = [];
					for (const resource of this.selectedResources) {
						linkedResources.push(resource.resourceID);
					}
					if (linkedResources.length > 0) {
						data.linkedResource = linkedResources;
					}
				} else if (this.action === 'editResource') {
					data.linkedResource = [];
				}

				if (Object.keys(visibility).length > 0) {
					data.settings = {
						visibility
					};
				}

				let apiValue;
				let formData;
				let durationInSeconds;
				data.resourceFormat = this.resourceFormatData.value;
				if (this.resourceFormatData.key === 'document') {
					let extraData: any = {};
					if (formValue.uploadFile) {
						if (formValue.uploadFile instanceof File) {
							extraData.file = formValue.uploadFile;
							durationInSeconds = this.gfService.getTimeToSeconds(formValue.duration, { timeFormat: 'hh:mm:ss' });
						} else {
							if (!formValue.uploadFile.name) {
								extraData = {
									file: formValue.uploadFile.file
								};
							}
						}
					}
					if (formValue.duration) {
						extraData.resource = {
							duration: formValue.duration
						};
					}
					apiValue = this.gfService.JSONMerge(data, extraData);
				} else if (this.resourceFormatData.key === 'video' && formValue.uploadVideo && typeof formValue.uploadVideo.videoFile !== 'string') {
					const extraData: any = {};
					if (formValue.uploadVideo.videoFile instanceof File) {
						extraData.file = formValue.uploadVideo.videoFile;
					}
					if (formValue.uploadVideo.thumbnail) {
						extraData.thumbnail = formValue.uploadVideo.thumbnail;
					}
					if (formValue.uploadVideo.duration) {
						// extraData.duration = formValue.uploadVideo.duration;
						extraData.resource = {
							duration: formValue.uploadVideo.duration
						};
						durationInSeconds = this.gfService.getTimeToSeconds(formValue.uploadVideo.duration, { timeFormat: 'hh:mm:ss' });
					}
					apiValue = this.gfService.JSONMerge(data, extraData);
				} else if (this.resourceFormatData.key === 'audio' && formValue.audioUpload && typeof formValue.audioUpload.audioFile !== 'string') {
					const extraData: any = {};
					if (formValue.audioUpload.audioFile instanceof File) {
						extraData.file = formValue.audioUpload.audioFile;
					}
					if (formValue.audioUpload.thumbnail) {
						extraData.thumbnail = formValue.audioUpload.thumbnail;
					}
					if (formValue.audioUpload.duration) {
						extraData.resource = {
							duration: formValue.audioUpload.duration
						};
						durationInSeconds = this.gfService.getTimeToSeconds(formValue.audioUpload.duration, { timeFormat: 'hh:mm:ss' });
					}
					apiValue = this.gfService.JSONMerge(data, extraData);
				} else if (this.resourceFormatData.key === 'link') {
					if (formValue.embed) {
						apiValue = this.gfService.JSONMerge(data, {
							resource: {
								link: formValue.embed.link,
								thumbnail: formValue.embed.image
							}
						});
					} else {
						apiValue = data;
					}
				} else if (this.resourceFormatData.key === 'page') {
					function extractContent(htmlString) {
						let span = document.createElement('span');
						span.innerHTML = htmlString;
						return span.innerText.split(' ').length;
					};
					let wordsLength = extractContent(formValue.page);
					const duration = this.gfService.getEstimatedReadingTime(wordsLength, 'hh:mm');
					apiValue = this.gfService.JSONMerge(data, {
						resource: {
							innerHtml: formValue.page,
							duration
						}
					});
				} else if (this.resourceFormatData.key === 'image' && formValue.imageUpload) {
					let caption = [];
					formValue.imageUpload.map((imageValue, index) => {
						if (!imageValue.removed) {
							let pushData = imageValue.caption;
							if (!pushData) {
								pushData = '';
							}
							caption.push(pushData);
						}
					});
					data.caption = caption;
					apiValue = data;
					// apiValue = this.gfService.JSONMerge(data, { file: temp });
				} else {
					delete data.resourceFormat;
					apiValue = data;
				}


			
				formData = this.gfService.convertToFormData(apiValue);
				if (formValue.imageUpload && Array.isArray(formValue.imageUpload) && formValue.imageUpload.length) {
					formValue.imageUpload.map(async (resp) => {
						if (!resp.removed) {
							formData.append('image', resp.file);
						}
					});
				}
				let method;
				let msg;
				if (!this.externalEventAdd && !this.moocAdd) {
					if (this.action === 'addResource') {
						msg = 'resource_submitted';
						
						method = this.apiService.saveResource(formData, headers);
					} else if (this.action === 'editResource') {
						msg = 'resource_updated';
						method = this.apiService.updateResource(formData, this.resourceDetail.resourceID, headers);
					} else if (this.action === 'editBeadResource') {
						msg = 'bead_updated';
						method = this.knowledgeBeadApiService.updateBead(formData, this.resourceDetail.resourceID, headers);
					}
				} else if (this.externalEventAdd) {
					if (this.action === 'addResource') {
						msg = 'event_created';
						method = this.externalEventApiService.saveExternalEvent(formData, headers);
					} else if (this.action === 'editResource') {
						msg = 'event_updated';
						method = this.externalEventApiService.updateExternalEvent(formData, this.resourceDetail.resourceID, headers);
					}
				} else if (this.moocAdd) {
					if (this.action === 'addResource') {
						msg = 'mooc_created';
						method = this.moocApiService.saveMOOC(formData, headers);
					} else if (this.action === 'editResource') {
						msg = 'mooc_updated';
						method = this.moocApiService.updateMOOC(formData, this.resourceDetail.resourceID, headers);
					}
				}

				method.subscribe(
					async (response) => {
						if (response) {
							this.popupRef.close(this.gfService.JSONMerge(apiValue, response));
							this.gfService.openSnackBar('SUCCESS', {
								message: this.locale.translate(msg),
								icon: 'check_circle_outline',
								position: 'before'
							});
						}
					},
					(error) => {
						this.gfService.alertHandler(error, 'addResourceAlert', 'ERROR');
						this.gfService.formErrorHandler(error, this.formObjectData.form);
						this.gfService.formErrorHandler(error, this.skillFormObject.form);
						this.gfService.formErrorHandler(error, this.keywordsFormObject.form);
					}
				)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.gfService.fieldControlMarkAsTouched(this.skillFormObject.fields, this.skillFormObject.form);
				this.gfService.fieldControlMarkAsTouched(this.keywordsFormObject.fields, this.keywordsFormObject.form);
				this.submitDisable = false;
			}
		}
	}

	async createScorm() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('addResourceAlert');
			const resourceFormValid = (this.resourceFormObject) ? this.resourceFormObject.form.valid : true;

			if (this.formObjectData.form.valid && resourceFormValid) {
				const headers: any = {};
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				let method;
				let msg;
				if (this.action === 'addScorm') {
					try {
						if (!this.uploadFailed) {
							this.fileName = await this.uploadScromFile(formValue?.uploadFile?.file?.value ? formValue?.uploadFile?.file?.value : formValue?.uploadFile )
						} else {
							this.fileName = await this.resumeUpload(formValue?.uploadFile?.file?.value ? formValue?.uploadFile?.file?.value : formValue?.uploadFile)
						}
					} catch (error) {
						if (error) {
							this.uploadFailed = true;
						}
						
					}
				} else if (this.action === 'editScorm') {
					let formData: any = {
						title: formValue.title,
						description: formValue.description
					};
					msg = 'scorm_updated';
					method = this.apiService.updateScormResource(formData, this.resourceDetail.resourceID, headers);
					method.subscribe(
						async (response) => {
							if (response) {
								this.popupRef.close(this.gfService.JSONMerge(formData, response));
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate(msg),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							this.gfService.alertHandler(error, 'addResourceAlert', 'ERROR');
							this.gfService.formErrorHandler(error, this.formObjectData.form);
						}
					)
						.add(() => {
							this.popupRef.close(this.gfService.JSONMerge({},{}));
							this.submitDisable = false;
							if (this.helpTriggered) {
								this.loader = false;
							} else {
								this.popupRef.componentInstance.popupLoader = false;
							}
						});
				}
				if (![undefined, null, ''].includes(this.fileName) && this.action === 'addScorm') {
					let formData: any = {
						title: formValue.title,
						description: formValue.description,
						scormFileName: this.fileName, //formValue.uploadFile?.file?.value ? formValue.uploadFile?.file?.value : formValue.uploadFile ,//this.fileName ,
						thumbnail: formValue.uploadFile?.thumbnail,
						languageCode: this.languageCode,
					};
					formData = this.gfService.convertToFormData(formData);
					method = this.apiService.saveScormResource(formData, headers);
					msg = 'scorm_created'
					method.subscribe(
						 (response) => {
							if (response) {
								this.fileCompleted = 1;
								localStorage.removeItem('fileUploadData');
							}
							
						},
						(error) => {
							if (error.error && error.error.statusCode === 400) {
								this.uploadFailed = false;
								this.showUploadProgress = false;
								this.progress = 0;
								this.gfService.errorHandler(error, {
									alert: {
										id: 'addResourceAlert'
									},
									form: this.formObject.form
								});
							} else {
								this.uploadFailed = true;
								this.gfService.alertHandler(error, 'addResourceAlert', 'ERROR');
								this.gfService.formErrorHandler(error, this.formObjectData.form);
							}

						}
					)
						.add(() => {
							this.submitDisable = false;
							if (this.helpTriggered) {
								this.loader = false;
							} else {
								this.popupRef.componentInstance.popupLoader = false;
							}
						});
				}


			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	fileToBinary(data) {
		var data_string = "";
		for (var i = 0; i < data.length; i++) {
			data_string += String.fromCharCode(data[i].charCodeAt(0) & 0xff);
		}
		return data_string;
	}

	async readPdfFile(file) {
		return new Promise(async (resolve, reject) => {
			const fileDataURL: any = await this.gfService.fileToDataURL(file);
			pdfjsLib.getDocument({ data: atob(fileDataURL.substring("data:application/pdf;base64,".length)) })
				.promise
				.then(async (PDFDocumentInstance) => {
					let totalWordCount = 0;
					for (let i = 1; i <= PDFDocumentInstance.numPages; i++) {
						let wordCount = await this.getPageText(i, PDFDocumentInstance);
						// console.log(wordCount);
						totalWordCount += wordCount;
					}
					return totalWordCount;
				}).then((wordCount) => {
					resolve(wordCount);
				});
		});
	}

	async getPageText(pageNum, PDFDocumentInstance): Promise<any> {
		return new Promise(async (resolve, reject) => {
			PDFDocumentInstance.getPage(pageNum).then((pdfPage) => {
				pdfPage.getTextContent().then((textContent) => {
					// console.log(textContent, pageNum)
					let textItems = textContent.items;
					// console.log(textItems)
					let wordCount = 0;
					for (let i = 0; i < textItems.length; i++) {
						let item = textItems[i];
						if (item.str.match(/\w+|\d+/g)) {
							// console.log(item.str.match(/\w+|\d+/g).length, item.str);
							wordCount += item.str.match(/\w+|\d+/g).length;
						}
					}
					// if (pageNum === PDFDocumentInstance.numPages) {
					// 	console.log(pageNum, this.wordsCount, wordCount);
					// }
					return wordCount;
				}).then((wordCount) => {
					resolve(wordCount);
				});
			});
		});
	}

	updateGeneralSettings() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('addResourceAlert');
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				if (Array.isArray(formData.rating)) {
					if (formData.rating[0] !== null) {
						formData.rating = formData.rating[0];
					} else {
						formData.rating = false;
					}
				}
				if (Array.isArray(formData.flagging)) {
					if (formData.flagging[0] !== null) {
						formData.flagging = formData.flagging[0];
					} else {
						formData.flagging = false;
					}
				}
				const channel = [];
				if (formData.hasOwnProperty('channel')) {
					if (Array.isArray(formData.channel) && formData.channel.length) {
						formData.channel.map(resp => {
							if (resp.isAdd && !resp.isDelete) {
								channel.push(Number(resp.key));
							}
						});
					}
				}
				formData.channel = channel;

				// const departments = [];
				// if (formData.hasOwnProperty('departments')) {
				// 	if (Array.isArray(formData.departments) && formData.departments.length) {
				// 		formData.departments.map(resp => {
				// 			if (resp.isAdd && !resp.isDelete) {
				// 				departments.push(Number(resp.key));
				// 			}
				// 		});
				// 		formData.department = departments;
				// 	}
				// 	if (!formData.department || (formData.department && Array.isArray(formData.department) && !formData.department.length)) {
				// 		formData.department = null;
				// 	}
				// 	delete formData.departments;
				// }
				// const functionalRoles = [];
				// if (formData.hasOwnProperty('functionalRoles')) {
				// 	if (Array.isArray(formData.functionalRoles) && formData.functionalRoles.length) {
				// 		formData.functionalRoles.map(resp => {
				// 			if (resp.isAdd && !resp.isDelete) {
				// 				functionalRoles.push(Number(resp.key));
				// 			}
				// 		});
				// 		formData.functionalRole = functionalRoles;
				// 	}
				// 	if (!formData.functionalRole || (formData.functionalRole && Array.isArray(formData.functionalRole) && !formData.functionalRole.length)) {
				// 		formData.functionalRole = null;
				// 	}
				// 	delete formData.functionalRoles;
				// }
				// const countries = [];
				// if (formData.hasOwnProperty('countries')) {
				// 	if (Array.isArray(formData.countries) && formData.countries.length) {
				// 		formData.countries.map(resp => {
				// 			if (resp.isAdd && !resp.isDelete) {
				// 				countries.push(Number(resp.key));
				// 			}
				// 		});
				// 		formData.country = countries;
				// 	}
				// 	if (!formData.country || (formData.country && Array.isArray(formData.country) && !formData.country.length)) {
				// 		formData.country = null;
				// 	}
				// 	delete formData.countries;
				// }
				let apiData: any = {};
				if (this.tabIndex === 0) {
					apiData = formData;
				} else if (formData && Object.keys(formData).length) {
					apiData = {
						visibility: formData
					};
				}
				const headers: any = {};
				this.apiService.updateSettings(apiData, this.resourceDetail.resourceID, headers).subscribe(
					(response) => {
						this.popupRef.close(apiData);
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('settings_updated'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							alert: {
								id: 'addResourceAlert'
							},
							form: this.formObject.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	reject() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('addResourceAlert');
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const policy = [];
				if (formData.policyDeviation && formData.policyDeviation.length) {
					formData.policyDeviation.map((resp, index) => {
						if (resp) {
							policy.push(this.formFields[0].options[index].key);
						}
					});
				}
				formData.policyDeviation = policy;
				let method;
				if (this.resourceDetail.resourceTypeID) {
					if (this.resourceDetail.resourceTypeID.key === 'playlist') {
						method = this.apiService.moderatePlaylist(formData, this.resourceDetail.resourceID, 4, headers);
					} else if (this.resourceDetail.resourceTypeID.key === 'knowledgeBead') {
						method = this.apiService.moderateKnowledgeBead(formData, this.resourceDetail.resourceID, 4, headers);
					} else {
						let status;
						const resourceStatus = this.baseService.resourceStatus;
						for (const statusData of resourceStatus) {
							if (statusData.key === 'rejected') {
								status = statusData.value;
							}
						}
						if (this.resourceDetail.resourceTypeID.key === 'mooc') {
							method = this.moocApiService.moderate(formData, this.resourceDetail.resourceID, status, headers);
						} else if (this.resourceDetail.resourceTypeID.key === 'internalEvent') {
							method = this.internalEventApiService.moderate(formData, this.resourceDetail.resourceID, status, headers);
						} else if (this.resourceDetail.resourceTypeID.key === 'externalEvent') {
							method = this.externalEventApiService.moderate(formData, this.resourceDetail.resourceID, status, headers);
						} else {
							formData.status = status;
							formData.resourceID = this.resourceDetail.resourceID;
							formData.notificationType = 1;
							if (this.deviceDetails.browserName === 'Safari') {
								formData.notificationType = 2;
							}
							method = this.apiService.moderateResource(formData, headers);
						}

					}
				}
				method.subscribe(
					(response) => {
						this.popupRef.close(formData);
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('submission_rejected'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							alert: {
								id: 'addResourceAlert'
							},
							form: this.formObject.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	makePublic() {
		if (this.makePublicFormObject && this.makePublicFormObject.form) {
			this.submitDisable = true;
			const headers: any = {};
			this.gfService.alertClear('addResourceAlert');
			if (this.makePublicFormObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const apiData = this.gfService.fieldSubmitApiValueConstruct(
					this.makePublicFormObject.form.getRawValue(),
					this.makePublicFormObject.fields
				);
				const taggedUsers = [];
				if (apiData && apiData.taggedUsers) {
					for (const user of apiData.taggedUsers) {
						if (user.isAdd && !user.isDelete) {
							taggedUsers.push(user.key);
						}
					}
				}
				apiData.taggedUsers = taggedUsers;
				this.apiService.makePublic(apiData, this.resourceDetail.resourceID, headers).subscribe(
					(response) => {
						this.popupRef.close(apiData);
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('marked_as_public'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							alert: {
								id: 'addResourceAlert'
							},
							form: this.makePublicFormObject.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.makePublicFormObject.fields, this.makePublicFormObject.form);
				this.submitDisable = false;
			}
		}
	}

	guideline() {
		this.popupRef.close('close');
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'guideline'
					}
				]
			},
			disableClose: true,
			maxWidth: '600px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
		});
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		let content = '';
		let title = '';
		let buttons = [
			{
				type: 'main-action',
				caption: this.locale.translate('yes'),
				key: 'yes'
			},
			{
				type: 'main-action',
				caption: this.locale.translate('no'),
				key: 'no',
				autoFocus: true
			}
		];
		if (action === 'removeThumbnail') {
			buttons = [
				{
					type: 'main-action',
					caption: this.locale.translate('yes'),
					key: 'yes'
				},
				{
					type: 'main-action',
					caption: this.locale.translate('cancel'),
					key: 'cancel',
					autoFocus: true
				}
			];
			content = this.locale.translate('use_this_feature_for_minor_correction_text');
			title = this.locale.translate('replace_content');
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title,
				content,
				buttons,
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'removeThumbnail') {
						this.removeThumbnail();
					}
				}
			}
		});
	}

	removeThumbnail() {
		if (this.currentFieldColumn) {
			const field = this.formFields.find(items => items.fieldColumn === this.currentFieldColumn);
			if (field) {
				field.isHidden = false;
				if (this.formObjectData.form && this.formObjectData.form.controls && this.formObjectData.form.controls[this.currentFieldColumn]) {
					this.formObjectData.form.controls[this.currentFieldColumn].enable({ emitEvent: false });
				}
			}
			this.showThumbnail = false;
		}
	}

	async resumeUpload(video: File) {
		try {
			this.uploadFailed = false;
			this.showUploadProgress = true;
			const dataString = localStorage.getItem('fileUploadData');
			const data = JSON.parse(dataString);
			const totalFileSize = video.size;
			const chunksCount = Math.ceil(totalFileSize / this.FIXED_CHUNK_SIZE);
			if(data && Array.isArray(data.parts)){
				 // sort parts array
				 data.parts.sort((a, b) => {
					if(+a.PartNumber > +b.PartNumber) return 1;
					if(+a.PartNumber < +b.PartNumber) return -1;
					return 0;
				});
				const completedParts = data.parts.length;
				const headers: any = {};
				
				for (let i = completedParts; i < chunksCount; i++) {
					const offset = i * this.FIXED_CHUNK_SIZE;
					const fileChunk = video.slice(offset, offset + this.FIXED_CHUNK_SIZE);
					const partUploadResult = await this.apiService.uploadPart(
						this.uploadType,
						data.fileName,
						this.setUploadID,
						(i + 1).toString(),
						fileChunk,
						headers
					)
					// .pipe(
					// 	map(event => this.getEventMessage(event,(i + 1).toString() ))
					// )
					.toPromise();
					this.progress = Math.round(((i + 1) / chunksCount) * 100);
					data.parts.push({
						PartNumber: (i + 1).toString(),
						ETag: partUploadResult.body.ETag,
					});

					const newDataString = JSON.stringify(data);
					localStorage.setItem('fileUploadData', newDataString);
				}
				await this.apiService.completeUpload(this.uploadType, data.fileName, data.UploadID, data.parts, headers).toPromise();
			}
			return data.fileName;

		} catch (error){
			console.log(error);
			if (error) {
				this.uploadFailed = true;
			}
		}
		
	}



	async uploadScromFile(video: File): Promise<string> {
		// console.log(video);
		this.showUploadProgress = true;
		const headers: any = {};
		const extension = video.name.split('.')[video.name.split('.').length - 1];
		const startUploadResult = await this.apiService.startUpload(this.uploadType, extension, headers).toPromise();
		// console.log(startUploadResult, "startUploadResult>>>>>")
		// Register in local storage
		const data = {
			uploadType: this.uploadType,
			fileName: startUploadResult?.fileName,
			UploadID: startUploadResult?.uploadID,
			parts: [],
		};
		const dataString = JSON.stringify(data);
		localStorage.setItem('fileUploadData', dataString);
		const parts: any = [];
		try {
			const totalFileSize = video.size;
			this.totalFileSizeInBytes = totalFileSize;
			const chunksCount = Math.ceil(totalFileSize / this.FIXED_CHUNK_SIZE);
			// console.log(totalFileSize, chunksCount);
			for (let i = 0; i < chunksCount; i++) {
				const offset = i * this.FIXED_CHUNK_SIZE;
				const fileChunk = video.slice(offset, offset + this.FIXED_CHUNK_SIZE);
				const partUploadResult = await this.apiService.uploadPartS(
					this.uploadType,
					startUploadResult.fileName,
					startUploadResult.uploadID,
					(i + 1).toString(),
					fileChunk,
					headers
				)
				// .pipe(
				// 	map(e => this.getEventMessage(e,(Number(i) + 1)))
				// )
				.toPromise();
				this.progress = Math.round(((i + 1) / chunksCount) * 100);
				// console.log(partUploadResult, "startUploadResult>>>>>")
				parts.push({
					PartNumber: (i + 1).toString(),
					ETag: partUploadResult.body.ETag,
				});
				const dataString = localStorage.getItem('fileUploadData');
				const data = JSON.parse(dataString);
				data.parts.push({
					PartNumber: (i + 1).toString(),
					ETag: partUploadResult.body.ETag
				});
				const newDataString = JSON.stringify(data);
				localStorage.setItem('fileUploadData', newDataString);
			}
			await this.apiService.completeUpload(this.uploadType, startUploadResult.fileName, startUploadResult.uploadID, parts, headers).toPromise();
			return  startUploadResult.fileName;

		} catch (error) {
			if (error) {
				if (startUploadResult?.uploadID) {
					this.setUploadID = startUploadResult.uploadID;
				}
			}
			throw error
		}
	}


	// getEventMessage(e: HttpEvent<any>, i) {
	// 	console.log("getEventMessage>>>>")
	// 	switch (e.type){
	// 		case HttpEventType.UploadProgress: 
	// 		return this.fileUploadProgress(e, i);

	// 		case HttpEventType.Response: 
	// 		return this.aiResponse(e);
	// 		default:
    //       	return `Unhandled event: ${e.type}`;
	// 	}
	// }

	// fileUploadProgress(e, i) {
	// 	this.progress = ((i - 1) * this.FIXED_CHUNK_SIZE + e.loaded);
	// 	console.log(this.progress, "progress bar data>>>>")
	// }
	
	// aiResponse(e) {
	// 	console.log(this.progress, "progress bar data>>>>")
	// 	return e.body; 
	// }

	closePopup() {
		this.showUploadProgress = false
		this.popupRef.close(this.gfService.JSONMerge({},{}));
		this.gfService.openSnackBar('SUCCESS', {
			message: this.locale.translate('scorm_created'),
			icon: 'check_circle_outline',
			position: 'before'
		});
	}

	cancelPopup() {
		if(navigator.onLine){
			this.showUploadProgress = false;
			this.progress = 0;
			this.popupRef.close(this.gfService.JSONMerge({},{}));
			localStorage.removeItem('fileUploadData');
		}
	}
}
